import { useEffect, useState, Fragment } from "react";
import styles from "../../../style/components/chat/ChatView.module.css";
import ChatShimmer from "../../ui/Loader/Shimmer/ChatShimmer";
import NoChatFound from "../../ui/NoDataFound/NoChatFound";
import { GrDownload } from "react-icons/gr";
import { FaPlus } from "react-icons/fa";
import EmojiPicker from "emoji-picker-react";
import WebSocketService from "../../../services/websocket";
import { getRegisterId } from "../../../utils/authId";
import { Emoji } from "emoji-picker-react";
import { renderTextWithEmojis } from "../../../utils/renderTextWithEmojis";
import { getUserDetails } from "../../../utils/auth";
import FallbackAvatar from "../../ui/FallbackAvatar/FallbackAvatar";
import ImagePreview from "./ImagePreview";

const parseDelta = (delta, messageId) => {
  if (!Array.isArray(delta)) return null;

  const cleanedDelta = [...delta];
  if (cleanedDelta.length > 0) {
    const lastOp = cleanedDelta[cleanedDelta.length - 1];
    if (lastOp.insert && typeof lastOp.insert === "string") {
      lastOp.insert = lastOp.insert.replace(/\n+$/, "");
    }
  }

  return cleanedDelta.map((op, opIndex) => {
    if (!op.insert || typeof op.insert !== "string") return null;

    let content = renderTextWithEmojis(op.insert, `${messageId}-${opIndex}`);

    if (op.attributes) {
      if (op.attributes.underline) {
        content = <u key={`u-${messageId}-${opIndex}`}>{content}</u>;
      }
      if (op.attributes.italic) {
        content = <em key={`em-${messageId}-${opIndex}`}>{content}</em>;
      }
      if (op.attributes.bold) {
        content = <strong key={`b-${messageId}-${opIndex}`}>{content}</strong>;
      }
      if (op.attributes.mention) {
        content = (
          <span
            key={`mention-${messageId}-${opIndex}`}
            className={styles.mentionText}
          >
            {content}
          </span>
        );
      }
    }

    return <Fragment key={`frag-${messageId}-${opIndex}`}>{content}</Fragment>;
  });
};

const ChatViewActivity = ({
  newReaction,
  messages,
  chatViewRef,
  isLoading,
  height,
  focusedMessageId,
  pendingMessages,
  chat_unique,
}) => {
  const processedMessages =
    messages
      ?.filter((msg) => msg.text?.trim() || (msg.file && msg.file.length > 0))
      .map((message, index, array) => {
        if (index === 0) {
          return { ...message, showHeader: true };
        }

        const prevMessage = array[index - 1];

        const isSameUser = prevMessage.userName === message.userName;
        const isSameMinute = isTimeInSameMinute(prevMessage.time, message.time);

        return {
          ...message,
          showHeader: !(isSameUser && isSameMinute),
        };
      }) || [];

  const groupedMessages = processedMessages.reduce((acc, message) => {
    const date = message.date;
    if (!acc[date]) acc[date] = [];
    acc[date].push(message);
    return acc;
  }, {});

  const sortedDates = Object.keys(groupedMessages).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  useEffect(() => {
    if (!chatViewRef?.current) return;
    console.log(focusedMessageId, "seleted");
    if (focusedMessageId) {
      const scrollToMessage = () => {
        const focusedElement = document.getElementById(
          `message-${focusedMessageId}`
        );
        if (focusedElement) {
          focusedElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          focusedElement.classList.add(styles.highlightMessage);
          setTimeout(() => {
            focusedElement.classList.remove(styles.highlightMessage);
          }, 2000);
        } else {
          setTimeout(scrollToMessage, 100);
        }
      };
      scrollToMessage();
    } else {
      chatViewRef.current.scrollTop = chatViewRef.current.scrollHeight;
    }
  }, [messages, focusedMessageId, chatViewRef]);

  if (isLoading) return <ChatShimmer />;
  if (!messages?.length) return <NoChatFound />;

  return (
    <div
      ref={chatViewRef}
      style={{
        height: "100%",
      }}
    >
      {" "}
      <div className={styles.ChatViewMaincontentChatviewsb}>
        {sortedDates.map((date) => (
          <div key={date}>
            <div className={styles.ChatViewDateSeparator}>
              <span>
                {new Date(date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>

            {groupedMessages[date].map((message, index) => (
              <Message
                key={`${date}-${index}`}
                {...message}
                newReaction={newReaction}
                chat_unique={chat_unique}
              />
            ))}
            {pendingMessages && (
              <div className={styles.customLoader}>
                <div className={styles.loaderBubble}>
                  <div className={styles.loaderDots}>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                  </div>
                  <span className={styles.customLoaderpara}>Sending...</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const isTimeInSameMinute = (time1, time2) => {
  if (!time1 || !time2) return false;

  const extractTimePart = (timeStr) => {
    const timeMatch = timeStr.match(/(\d{1,2}:\d{2})/);
    return timeMatch ? timeMatch[1] : timeStr;
  };

  const timePart1 = extractTimePart(time1);
  const timePart2 = extractTimePart(time2);

  return timePart1 === timePart2;
};
const Message = ({
  id,
  isReceived,
  userName,
  text,
  file,
  time,
  avatar,
  reactions,
  newReaction,
  chat_unique,
  showHeader = true,
}) => {
  console.log(id, "Mesaageid");
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showReactionPicker, setShowReactionPicker] = useState(false);
  const commonReactions = ["👍", "❤️", "😂", "😮", "😢", "🙏"];
  const [showEmojiPopup, setShowEmojiPopup] = useState(false);
  const currentUserId = getRegisterId();
  const [imgError, setImgError] = useState(false);
  const userDetails = getUserDetails();
  const [hoveredReaction, setHoveredReaction] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const [transformedReactions, setTransformedReactions] = useState(
    reactions?.map((reaction) => ({
      emoji: reaction.react_emoji,
      count: reaction.reaction_count,
      userReacted: reaction.react_people_names.some(
        (user) => user.register_id === currentUserId
      ),
      people: reaction.react_people_names,
    })) || []
  );

  useEffect(() => {
    if (newReaction && newReaction.reaction?.message_id === id) {
      setTransformedReactions((prev) => {
        const existing = prev.find(
          (r) => r.emoji === newReaction.reaction.emoji
        );

        if (newReaction.action === "add") {
          if (existing) {
            return prev.map((r) =>
              r.emoji === newReaction.reaction.emoji
                ? {
                    ...r,
                    count: r.count + 1,
                    userReacted:
                      r.people.some(
                        (user) => user.register_id === currentUserId
                      ) || r.userReacted,
                    people: [
                      ...new Set([
                        ...r.people,
                        ...newReaction.reaction.react_people_names,
                      ]),
                    ],
                  }
                : r
            );
          } else {
            return [
              ...prev,
              {
                emoji: newReaction.reaction.emoji,
                count: 1,
                userReacted: newReaction.reaction.react_people_names.some(
                  (user) => user.register_id === currentUserId
                ),
                people: newReaction.reaction.react_people_names || [],
              },
            ];
          }
        } else if (newReaction.action === "remove") {
          const senderId = newReaction.sender_id;

          return prev
            .map((r) =>
              r.emoji === newReaction.reaction.emoji
                ? {
                    ...r,
                    count: r.count - 1,
                    userReacted: r.people.some(
                      (user) =>
                        user.register_id === currentUserId &&
                        user.register_id !== senderId
                    ),
                    people: r.people.filter(
                      (user) => user.register_id !== senderId
                    ),
                  }
                : r
            )
            .filter((r) => r.count > 0);
        }

        return prev;
      });
    }
  }, [newReaction, id, currentUserId]);

  const handleAddReaction = (emoji) => {
    WebSocketService.sendReaction(id, chat_unique, emoji, "add");

    setTransformedReactions((prev) => {
      const existingReaction = prev.find((r) => r.emoji === emoji);

      if (existingReaction) {
        return prev.map((r) =>
          r.emoji === emoji
            ? {
                ...r,
                count: r.count + 1,
                userReacted: true,
                people: [
                  ...r.people,
                  { register_id: currentUserId, name: userDetails.name },
                ],
              }
            : r
        );
      } else {
        return [
          ...prev,
          {
            emoji,
            count: 1,
            userReacted: true,
            people: [{ register_id: currentUserId, name: userDetails.name }],
          },
        ];
      }
    });

    setShowReactionPicker(false);
  };

  const handleRemoveReaction = (emoji) => {
    WebSocketService.sendReaction(id, chat_unique, emoji, "remove");

    setTransformedReactions((prev) =>
      prev
        .map((r) =>
          r.emoji === emoji
            ? {
                ...r,
                count: r.count - 1,
                userReacted: false,
                people: r.people.filter(
                  (user) => user.register_id !== currentUserId
                ),
              }
            : r
        )
        .filter((r) => r.count > 0)
    );
  };

  const toggleReaction = (emoji) => {
    const existingReaction = transformedReactions.find(
      (r) => r.emoji === emoji
    );
    if (
      existingReaction?.people.some(
        (user) => user.register_id === currentUserId
      )
    ) {
      handleRemoveReaction(emoji);
    } else {
      handleAddReaction(emoji);
    }
  };

  const getFileType = (extension) => {
    extension = extension.toLowerCase();
    const typeMap = {
      doc: "word",
      docx: "word",
      pdf: "pdf",
      jpg: "image",
      jpeg: "image",
      png: "image",
      gif: "image",
      xls: "excel",
      xlsx: "excel",
      ppt: "powerpoint",
      pptx: "powerpoint",
      zip: "zip",
      rar: "zip",
      js: "js",
      py: "py",
      ts: "ts",
      jsx: "jsx",
      html: "html",
      css: "css",
      "7z": "zip",
      csv: "csv",
      pyz: "zip",
      java: "java",
      php: "php",
      txt: "txt",
      mp4: "video",
      mov: "video",
      avi: "video",
      mkv: "video",
      wmv: "video",
      flv: "video",
      webm: "video",
      mpeg: "video",
      mpg: "video",
      m4v: "video",
      apk: "apk",
      exe: "exe",
      "3gp": "video",
    };
    return typeMap[extension] || "file";
  };

  const handleDownload = async (url, fileName = "download") => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {},
      });

      if (!response.ok) {
        throw new Error("File download failed");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = blobUrl;
      anchor.setAttribute("download", fileName);
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const renderContent = () => {
    if (!text) return null;

    try {
      const delta = JSON.parse(text);
      if (Array.isArray(delta)) {
        return parseDelta(delta, id);
      }
    } catch (e) {
      return renderTextWithEmojis(text, `plain-${id}`);
    }

    return renderTextWithEmojis(text, `plain-${id}`);
  };

  const openImagePreview = (file) => {
    setSelectedImage(`${apiUrl}${file.file_url}`);
    setShowImageModal(true);
  };

  const closeImagePreview = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };
  return (
    <div className={styles.ChatViewMessageContainer} id={`message-${id}`}>
      <div className={styles.chatViewAllComp}>
        {showHeader ? (
          <div className={styles.ChatViewAvatar}>
            {imgError || !avatar ? (
              <FallbackAvatar name={userName} size={36} />
            ) : (
              <img
                src={avatar}
                alt={`${userName}'s avatar`}
                onError={() => setImgError(true)}
              />
            )}
          </div>
        ) : (
          <div className={styles.ChatViewAvatarSpacer}></div>
        )}
        <div className={styles.ChatViewMessageContent}>
          {showHeader && (
            <div className={styles.ChatViewHeader}>
              <span className={styles.ChatViewUsername}>{userName}</span>
              <span className={styles.ChatViewTime}>
                {" "}
                • {time.replace(/:\d{2}\s/, " ")}
              </span>
            </div>
          )}
          <div
            className={`${styles.ChatViewBubble} ${
              !showHeader ? styles.noHeader : ""
            }`}
          >
            {" "}
            {text && (
              <span className={styles.ChatViewUserTextChat}>
                {" "}
                {renderContent()}
              </span>
            )}
            {file?.length > 0 && (
              <div
                className={styles.filesContainer}
                style={{
                  gridTemplateColumns:
                    file.length === 1
                      ? "1fr"
                      : file.length === 2
                      ? "repeat(2, 1fr)"
                      : "repeat(3, 1fr)",
                }}
              >
                {file.map((file, index) => (
                  <div key={index} className={styles.fileItemWrapper}>
                    {["jpg", "jpeg", "png", "gif"].includes(
                      file.file_extension.toLowerCase()
                    ) ? (
                      <div
                        className={`${styles.fileItem} ${
                          styles[getFileType(file.file_extension)]
                        }`}
                      >
                        <div
                          className={styles.fileIcon}
                          onClick={() => openImagePreview(file)}
                        >
                          <img
                            src={`${apiUrl}${file.file_url}`}
                            alt={file.file_extension}
                            className={styles.fileTypeImageIcon}
                          />
                        </div>
                        <div className={styles.fileInfo}>
                          <div className={styles.fileName}>
                            {file.file_name}
                          </div>
                          {file.file_size && (
                            <div className={styles.fileSize}>
                              {formatFileSize(file.file_size)}
                            </div>
                          )}
                        </div>
                        <GrDownload
                          className={styles.downloadButton}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownload(
                              `${apiUrl}${file.file_url}`,
                              file.file_name
                            )
                          }
                        />{" "}
                      </div>
                    ) : (
                      <div
                        className={`${styles.fileItem} ${
                          styles[getFileType(file.file_extension)]
                        }`}
                      >
                        <div className={styles.fileIcon}>
                          <img
                            src={`Images/Icons/${getFileType(
                              file.file_extension
                            )}.png`}
                            alt={file.file_extension}
                            className={styles.fileTypeImageIcon}
                          />
                        </div>
                        <div className={styles.fileInfo}>
                          <div className={styles.fileName}>
                            {file.file_name}
                          </div>
                          {file.file_size && (
                            <div className={styles.fileSize}>
                              {formatFileSize(file.file_size)}
                            </div>
                          )}
                        </div>
                        <GrDownload
                          className={styles.downloadButton}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownload(
                              `${apiUrl}${file.file_url}`,
                              file.file_name
                            )
                          }
                        />{" "}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            {transformedReactions.length > 0 && (
              <div className={styles.messageReactionsOuter}>
                {transformedReactions.map((reaction, index) => {
                  const isCurrentUserReacted = reaction.people.some(
                    (user) => user.register_id === currentUserId
                  );
                  const getFirstCodePoint = (emoji) => {
                    if (emoji.includes("\ufe0f")) {
                      return Array.from(emoji)
                        .map((char) => char.codePointAt(0).toString(16))
                        .join("-");
                    }

                    const chars = Array.from(emoji);
                    if (chars.length > 1) {
                      return chars
                        .map((char) => char.codePointAt(0).toString(16))
                        .join("-");
                    }

                    return chars[0].codePointAt(0).toString(16);
                  };
                  return (
                    <div
                      key={index}
                      className={`${styles.reactionBadgeOuter} ${
                        isCurrentUserReacted ? styles.userReacted : ""
                      }`}
                      onClick={() => toggleReaction(reaction.emoji)}
                      onMouseEnter={() => setHoveredReaction(reaction)}
                      onMouseLeave={() => setHoveredReaction(null)}
                    >
                      <span>
                        <Emoji
                          unified={getFirstCodePoint(reaction.emoji)}
                          size={14}
                        />
                      </span>
                      {reaction.count > 1 && (
                        <span style={{ color: "gray" }}>{reaction.count}</span>
                      )}
                      {hoveredReaction === reaction && (
                        <div className={styles.reactionTooltip}>
                          <div style={{ textAlign: "center" }}>
                            <Emoji
                              unified={getFirstCodePoint(reaction.emoji)}
                              size={25}
                            />
                          </div>
                          <div>
                            {reaction.people.map((person, idx) => (
                              <span key={person.register_id}>
                                {person.name}
                                {idx < reaction.people.length - 1 ? ", " : ""}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        {showReactionPicker && (
          <div className={styles.reactionPickerOuter}>
            {commonReactions.map((emoji, index) => (
              <div
                key={index}
                className={styles.reactionItem}
                onClick={() => toggleReaction(emoji)}
              >
                {emoji}
              </div>
            ))}
            <div
              className={styles.reactionItem}
              onClick={() => {
                setShowReactionPicker(false);
                setShowEmojiPopup(true);
              }}
            >
              <FaPlus />
            </div>
          </div>
        )}
        {showEmojiPopup && (
          <div className={styles.emojiPickerContainerViewChat}>
            <EmojiPicker
              onEmojiClick={(emojiObject) => {
                toggleReaction(emojiObject.emoji);
                setShowEmojiPopup(false);
              }}
              width={300}
              height={400}
              skinTonesDisabled
              searchDisabled
            />
          </div>
        )}
        {showImageModal && selectedImage && (
          <div className={styles.emojiPickerContainerViewChat}>
            <ImagePreview
              onClose={closeImagePreview}
              selectedImage={selectedImage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export default ChatViewActivity;
